import React from 'react';
import { withRouter, Redirect, RouteComponentProps } from 'react-router';
import { adminConsoleFallbackPath } from '../admin-console-side-nav/admin-console-routes-map';

export const AdminConsoleFallbackPage = withRouter(({ match }: RouteComponentProps) => (
  <Redirect to={`${match.path}/${adminConsoleFallbackPath}`} />
));
